import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
 
export default function BasicTable(props) {
  const rows = Array.isArray(props.data) ? [...props.data] : [];
  const subjects = Array.isArray(props.subjects?.[0]) ? props.subjects[0] : (Array.isArray(props.subjects) ? props.subjects : []);
  const term = props.term;
  const showAggregate = props.showAggregate !== false;
  const showPosition = props.showPosition !== false;

  const normalizeValue = (value) => String(value || '').trim().toLowerCase();
  const normalizeComparable = (value) =>
    normalizeValue(value)
      .replace(/\s*\/\s*/g, '/')
      .replace(/\s+/g, ' ');

  const getAcademicRecord = (row) => {
    const records = Array.isArray(row?.academics2) ? row.academics2 : [];
    if (records.length === 0) return null;

    const hasSelectedTerm = term && normalizeValue(term) !== 'none';
    if (hasSelectedTerm) {
      return records.find((record) =>
        [record?.termId, record?.termName, record?.term]
          .filter(Boolean)
          .some((value) => normalizeComparable(value) === normalizeComparable(term))
      );
    }

    // Only fallback to latest when no term is selected.
    return records[records.length - 1];
  };

  const getSubjectTotal = (record, classSubject) => {
    if (!record || !Array.isArray(record.subjects)) return '';
    const normalizedTarget = normalizeValue(classSubject?.subject || classSubject?.subjectName || classSubject?.name);
    const found = record.subjects.find((subject) => {
      const candidates = [subject?.subjectId, subject?.subjectName, subject?.subject];
      return candidates.some((candidate) => normalizeValue(candidate) === normalizedTarget);
    });
    if (!found) return '';

    const value =
      found.totalScore ??
      found.total ??
      ((Number.parseFloat(found.classScore ?? found.class_scorre ?? 0) || 0) +
        (Number.parseFloat(found.examScore ?? found.exam_score ?? 0) || 0));
    return Number.isFinite(Number(value)) ? Number(value).toFixed(2) : value;
  };

  const getAggregateValue = (record) => {
    if (!record) return '';
    const aggregate = record.aggregateResults?.aggregate ?? record.aggregate ?? '';
    return aggregate === '' ? '' : String(aggregate);
  };

  const getPositionValue = (record) => {
    if (!record) return '';
    return record.aggregateResults?.overallPosition ?? record.position ?? '';
  };

  const getTotalValue = (record) => {
    if (!record) return '';
    const value =
      record.aggregateResults?.totalScore ??
      record.totalscore ??
      (Array.isArray(record.subjects)
        ? record.subjects.reduce((sum, subject) => {
            const subjectTotal =
              subject?.totalScore ??
              subject?.total ??
              ((Number.parseFloat(subject?.classScore ?? subject?.class_scorre ?? 0) || 0) +
                (Number.parseFloat(subject?.examScore ?? subject?.exam_score ?? 0) || 0));
            return sum + (Number.parseFloat(subjectTotal) || 0);
          }, 0)
        : '');
    return value === '' ? '' : Number.isFinite(Number(value)) ? Number(value).toFixed(2) : value;
  };

  rows.sort((a, b) => String(a.lastname || '').localeCompare(String(b.lastname || '')));

  return (
    <TableContainer>
      <Table sx={{ minWidth: "100%" }} aria-label="simple table">
        <TableHead>
          <TableRow>

                      <TableCell style={{ fontWeight:"bolder"}}>No.</TableCell>
                      <TableCell style={{ fontWeight:"bolder"}}>Student Name</TableCell>
                      {subjects.map((list,index)=>
                      <TableCell align="left" style={{fontWeight:"bolder"}}>{list.subject}</TableCell>
                      )}
                      <TableCell align="left" style={{color:"blue" , fontWeight:"bolder"}}>Total Score</TableCell>
                      {showAggregate && <TableCell align="left" style={{color:"green" , fontWeight:"bolder"}}>Aggregate</TableCell>}
                      {showPosition && <TableCell align="left" style={{color:"red" , fontWeight:"bolder"}}>Position</TableCell>}

          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, indexer) => {
            const academicRecord = getAcademicRecord(row);
            return (

 <TableRow
                  key={row.ID || row._id || indexer}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                      {indexer+1 +"."}
              </TableCell> <TableCell component="th" scope="row">
                      {row.lastname+" "+row.othernames}
              </TableCell>

              {subjects.map((subject, index) => (
                <TableCell key={`${row.ID || row._id || indexer}-${subject.subject || index}`} align="left">
                  {getSubjectTotal(academicRecord, subject)}
                </TableCell>
              ))}
             <TableCell align="left" style={{color:"blue", fontWeight:"bolder"}}>{getTotalValue(academicRecord)}</TableCell>
             {showAggregate && <TableCell align="left" style={{color:"green", fontWeight:"bolder"}}>{getAggregateValue(academicRecord)}</TableCell>}
             {showPosition && <TableCell align="left" style={{color:"red", fontWeight:"bolder"}}>{getPositionValue(academicRecord)}</TableCell>}
          </TableRow>)})} 
        </TableBody>
      </Table>
    </TableContainer>
  );
}
